import { render, staticRenderFns } from "./TennisRank.vue?vue&type=template&id=733ca116&scoped=true&"
import script from "./TennisRank.vue?vue&type=script&lang=js&"
export * from "./TennisRank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733ca116",
  null
  
)

export default component.exports